import React from 'react'
import Card from 'react-bootstrap/Card'

const descriptionSubtitleSection = (props) => {
    return (
        <>
            <Card.Subtitle className="mb-2 text-muted">{props.title}</Card.Subtitle>
            <Card.Text className={'subtitle-text'}>
                {props.children}
            </Card.Text>
        </>
    )
};
export default descriptionSubtitleSection;